export default __webpack_public_path__ + "static/media/profile.31cb96fd.svg";